import { create } from "zustand";
import { immer } from "zustand/middleware/immer";

interface State {
  isScrollSource: boolean;
}

interface Action {
  setIsScrollSource: (scroll: boolean) => void;
}

const stateStore = () => ({
  isScrollSource: false,
});

const actionStore = (set) => ({
  setIsScrollSource: (scroll: boolean) => {
    set((state) => {
      state.isScrollSource = scroll;
    });
  },
});

const useScrollStore = create<State & Action>()(
  immer((set) => ({
    ...stateStore(),
    ...actionStore(set),
  })),
);

export default useScrollStore;
